import { GridSortModel } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import {
  GetAllPharmacyLabRadiologyTypeEnum,
  PharmacyLabRadiologyControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  type?: GetAllPharmacyLabRadiologyTypeEnum;
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetPharmacyByType = ({
  patientUuid,
  pagination,
  gridSorting,
  type,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: [
      "patient-orders-list",
      patientUuid,
      pageIndex,
      pageSize,
      sortBy,
      searchString,
      sortDirect,
      xTENANTID,
      type,
    ],

    enabled: !skip && enabled,
    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PharmacyLabRadiologyControllerApi(getConfigObject())
        .getAllPharmacyLabRadiology(
          pagination.page,
          pageSize,
          sortBy,
          sortDirect,
          type,
          searchString ? searchString : undefined,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
